// components/shared/sites/SiteRow.tsx
import { Site } from "../../../types/features/Site";
import TableRow from "../../ui/TableRow";
import { Globe, ExternalLink } from "lucide-react";

interface SiteRowProps {
  site: Site;
  onAction: (site: Site) => void;
  onSelect?: (site: Site, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function SiteRow({
  site,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,
}: SiteRowProps) {
  const getStatusBadge = () => {
    return site.is_active
      ? { label: "Actif", className: "bg-green-100 text-green-700" }
      : { label: "Inactif", className: "bg-gray-100 text-gray-500" };
  };

  const statusBadge = getStatusBadge();

  return (
    <TableRow
      item={site}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          {site.logo ? (
            <img src={site.logo} alt={site.name} className="w-10 h-10 rounded-lg object-cover" />
          ) : (
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Globe className="w-5 h-5 text-primary" />
            </div>
          )}
          <div>
            <span className="font-medium text-gray-800 block">{site.name}</span>
            <span className="text-xs text-gray-500">/{site.slug}</span>
          </div>
        </div>
      </td>

      <td className="py-3 px-4">
        <span className="text-gray-600 text-sm">{site.domain || "-"}</span>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
          {site.default_locale.toUpperCase()}
        </span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusBadge.className}`}>
          {statusBadge.label}
        </span>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <span className="text-gray-500 text-sm">
          {new Date(site.created_at).toLocaleDateString("fr-FR")}
        </span>
      </td>
    </TableRow>
  );
}